<template>
  <div
    ref="card"
    class="card"
    :data-state="isMove ? 'move' : state"
    :style="{ top: `${isMove ? y : calcY()}px` }"
  >
    <!-- drag thing -->
    <!-- <div
      :class="['pan-area w-10', isSwipeOpen ? 'mb-4' : 'mb-0 absolute']"
      ref="pan"
    >
      <img
        src="../assets/images/arrow-down.svg"
        :class="[
          'w-12 m-auto rounded-full bg-primary-50 p-2 transform rotate-180',
          isSwipeOpen ? 'hidden' : 'block',
        ]"
      />
    </div> -->
    <div :class="['pan-area2 opacity']" ref="pan">
      <div class="bar" ref="bar" :style="{ backgroundColor: barColor }"></div>
    </div>
    <div
      id="swipeable-bottom-sheet"
      :class="[
        'contents h-screen overflow-hidden rounded-t-xl',
        isSwipeOpen
          ? 'overflow-scroll bg-white'
          : 'overflow-hidden bg-primary-100',
      ]"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Hammer from "hammerjs";
import { mapGetters } from "vuex";
export default {
  props: {
    openY: {
      type: Number,
      default: 0.12,
    },
    halfY: {
      type: Number,
      default: 0.88,
    },
    defaultState: {
      type: String,
      default: "close",
    },
    barColor: {
      // Added a bar color props
      type: String,
      default: "#495baa",
    },
  },
  computed: {
    ...mapGetters(["isSafari", "isSwipeOpen", "isIOSChrome"]),
  },
  data() {
    return {
      mc: null,
      y: 0.8,
      startY: 0.8,
      isMove: false,
      state: this.defaultState,
      rect: {},
    };
  },
  mounted() {
    window.onresize = () => {
      this.rect = this.$refs.card.getBoundingClientRect();
    };
    this.rect = this.$refs.card.getBoundingClientRect();
    this.mc = new Hammer(this.$refs.pan);
    this.mc.get("pan").set({ direction: Hammer.DIRECTION_ALL });
    this.mc.on("panup pandown", (evt) => {
      this.y = evt.center.y - 16;
      window.scrollTo(0, 0);
    });
    this.mc.on("panstart", (evt) => {
      this.startY = evt.center.y;
      this.isMove = true;
    });
    this.mc.on("panend", (evt) => {
      this.isMove = false;
      switch (this.state) {
        case "close": //Added a close state on the condition to be able to swipe from closed to half/closed state.
        case "half":
          if (this.state == "close") {
            if (this.startY - evt.center.y > 120) {
              this.state = "half";
            }
            if (this.startY - evt.center.y > 320) {
              this.state = "open";
            }
            break;
          }
          if (this.startY - evt.center.y > 120) {
            this.state = "open";
          }
          if (this.startY - evt.center.y < -50) {
            this.state = "close";
          }
          break;
        case "open":
          if (this.startY - evt.center.y < -120) {
            this.state = "half";
          }
          break;
      }
    });
  },
  beforeDestroy() {
    this.mc.destroy();
    window.onresize = null;
  },
  methods: {
    calcY() {
      switch (this.state) {
        case "close":
          return (
            this.$store.commit("updateIsSwipeOpen", false),
            this.isSafari || this.isIOSChrome
              ? this.rect.height * this.halfY - 90
              : this.rect.height * this.halfY - 40
          );
        case "open":
          return (
            this.$store.commit("updateIsSwipeOpen", true),
            this.rect.height * this.openY
          );
        case "half":
          return (
            this.$store.commit("updateIsSwipeOpen", false),
            this.isSafari
              ? this.rect.height * this.halfY - 90
              : this.rect.height * this.halfY - 40
          );
        default:
          return this.y;
      }
    },
    setState(state) {
      this.state = state;
    },
  },
};
</script>

<style scoped>
.wrapper[data-open="1"] {
  position: fixed;
  top: 0;
  left: 0;
}
.wrapper[data-open="1"] .bg {
  display: block;
  transition: all 0.3s;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}
.card {
  width: 100%;
  height: 100vh;
  position: fixed;
  background: white;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 -3px 4px rgba(0, 0, 0, 0.1);
  left: 0;
  border-radius: 30px;
}
.card[data-state="half"],
.card[data-state="open"],
.card[data-state="close"] {
  transition: top 0.3s ease-out;
}

.pan-area2 {
  top: 0px;
  right: 0;
  left: 0;
  height: 8px;
  padding: 12px 0;
  z-index: 20;
  margin: 0 auto;
  position: absolute;
}
.pan-area {
  top: -30px;
  right: 0;
  left: 0;
  height: 8px;
  padding: 12px 0;
  z-index: 20;
  margin: 0 auto;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
}
.bar:hover {
  cursor: grab;
}
.bar:active {
  cursor: grabbing;
}
.contents {
  max-height: 100%;
  padding-bottom: calc(100vh * 0.2);
  box-sizing: border-box;
}
</style>
